import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import { Fragment, useEffect, useState } from "react";
import { ActivityIndicator, Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";
import i18n from "../../translation/index";
import { PopupFactory } from "..";
import {
    ArrowRightIcon,
    AccessibilityIcon,
    GradingIcon
} from "../../assets/icons";
import { usePopup } from "../PopupFactory";
import ModalScreeningOption from "../ModalScreeningOptions";
import { getQuizIndicatorStatistics } from "../../services/survey";
import { getCharacterData, getCompletionCounts } from "../../Utils/characterStatistic";

const SurveyKarakterCard = ({
    data,
    additionalContentId,
    isScreening,
    isQuick,
}) => {
    const {
        quizId,
        totalPertanyaan,
        isNewPractice
    } = data || {};
    const [statistic, setStatistic] = useState(null);
    const [statisticsLoading, setStatisticsLoading] = useState(false);
    const [statisticsError, setStatisticsError] = useState(false);
    const characterData = getCharacterData(statistic, additionalContentId);
    const totalCharacters = Object.keys(characterData).length;
    const totalIndicators = Object.values(characterData).reduce(
        (total, indicators) => total + Object.keys(indicators || {}).length,
        0,
    );
    const completionCounts = getCompletionCounts(statistic, additionalContentId);
    const navigation = useNavigation();
    const { t } = useTranslation();
    const { toggle, visible } = usePopup();

    const [screeningOptionModal, setScreeningOptionModal] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const loadCompletionCounts = async () => {
            setStatistic(null);
            setStatisticsError(false);
            if (!additionalContentId) {
                setStatisticsLoading(false);
                return;
            }
            setStatisticsLoading(true);
            try {
                const response = await getQuizIndicatorStatistics(additionalContentId, controller.signal);
                if (isMounted) {
                    setStatistic(response.data);
                }
            } catch (error) {
                if (isMounted) {
                    setStatisticsError(true);
                }
            } finally {
                if (isMounted) setStatisticsLoading(false);
            }
        };

        loadCompletionCounts();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, [additionalContentId]);

    useEffect(() => {
        async function getLang() {
            return await AsyncStorage.getItem("lang");
        }

        getLang()
            .then((res) => {
                if (!res) {
                    AsyncStorage.setItem("lang", "id");
                    i18n.changeLanguage("id");
                    return;
                }
                AsyncStorage.setItem("lang", res);
                i18n.changeLanguage(res);
            });
    }, []);

    return (
        <Fragment>
            <TouchableOpacity
                onPress={() => navigation.navigate("SurveyDetail", { quizId, additionalContentId, isScreening, isNewPractice, isQuick, version: new Date().getTime() })}
            >
                <View style={styles.container}>
                    <View style={styles.content}>
                        <View style={styles.body}>
                            {statisticsLoading && <ActivityIndicator color="#6724E2" />}
                            {statisticsError && <Text style={styles.data}>Data pencapaian gagal dimuat.</Text>}
                            <View style={{ flex: 1, flexDirection: "row" }}>
                                <View style={{ flex: 1, paddingRight: 12, borderRightWidth: 1, borderRightColor: "#EAEAEA" }}>
                                    <View style={{ alignSelf: "flex-start", backgroundColor: "#EEEAFF", paddingHorizontal: 12, paddingVertical: 6, borderRadius: 6, marginBottom: 16 }}>
                                        <Text style={[styles.title, { color: "#6724E2" }]}>Pencapaian Karakter</Text>
                                    </View>

                                    <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 16, gap: 12 }}>
                                        <AccessibilityIcon width={40} height={40} fill="#000" />
                                        <View>
                                            <Text style={{ fontFamily: "Archivo-Bold", fontSize: 18, color: "#000" }}>{completionCounts.completedCharacters} dari {totalCharacters}</Text>
                                            <Text style={{ fontFamily: "Archivo-Regular", fontSize: 12, color: "#000" }}>Sudah Terisi</Text>
                                        </View>
                                    </View>

                                    {completionCounts.completedCharacters === 0 && <Text style={{ fontFamily: "Archivo-Regular", fontSize: 12, color: "#999" }}>Belum ada karakter yang terisi</Text>}
                                </View>

                                <View style={{ flex: 1, paddingLeft: 12 }}>
                                    <View style={{ alignSelf: "flex-start", backgroundColor: "#EEEAFF", paddingHorizontal: 12, paddingVertical: 6, borderRadius: 6, marginBottom: 16 }}>
                                        <Text style={[styles.title, { color: "#6724E2" }]}>Pencapaian Indikator</Text>
                                    </View>

                                    <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 16, gap: 12 }}>
                                        <GradingIcon width={40} height={40} fill="#000" />
                                        <View>
                                            <Text style={{ fontFamily: "Archivo-Bold", fontSize: 18, color: "#000" }}>{completionCounts.completedIndicators} dari {totalIndicators}</Text>
                                            <Text style={{ fontFamily: "Archivo-Regular", fontSize: 12, color: "#000" }}>Sudah Terisi</Text>
                                        </View>
                                    </View>

                                    {completionCounts.completedIndicators === 0 && <Text style={{ fontFamily: "Archivo-Regular", fontSize: 12, color: "#999" }}>Belum ada indikator yang terisi</Text>}
                                </View>
                            </View>
                        </View>
                        <View
                            style={[
                                styles.footer,
                                styles.flexRow,
                                { justifyContent: "space-between" },
                            ]}
                        >
                            <TouchableOpacity
                                style={[styles.flexRow, { flex: 1, justifyContent: "space-between" }]}
                                onPress={() => {
                                    navigation.navigate("SurveyKarakterList", {
                                        quizId,
                                        additionalContentId,
                                        isScreening,
                                        isNewPractice,
                                        isQuick,
                                    });
                                }}
                            >
                                <Text style={[styles.footerTx, { color: "#6724E2", fontSize: 14 }]}>
                                    {"Lihat Capaian Karakter per Siswa"}
                                </Text>
                                <ArrowRightIcon fill="#6724E2" />
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
            <PopupFactory
                type={"limit-screening"}
                visible={visible}
                onCancel={toggle}
                onSubmit={toggle}
                data={totalPertanyaan}
            />
            <ModalScreeningOption
                visible={screeningOptionModal}
                hideDialog={() => setScreeningOptionModal(false)}
                onFillScreening={() => {
                    navigation.navigate("Screening", { quizId, additionalContentId });
                    setScreeningOptionModal(false);
                }}
                onGoToReport={() => {
                    navigation.navigate("ScreeningReport", {
                        quizId,
                        additionalContentId,
                    });
                    setScreeningOptionModal(false);
                }}
            />
        </Fragment>
    );
};

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 12,
    },
    content: {
        backgroundColor: "#fff",
        borderRadius: 10,
    },
    image: {
        borderRadius: 10,
        width: "100%",
        height: 60,
    },
    title: {
        fontFamily: "Archivo-SemiBold",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 13,
        lineHeight: 16,
    },
    body: {
        paddingHorizontal: 12,
        paddingTop: 16,
        paddingBottom: 12,
        gap: 10,
    },
    data: {
        fontFamily: "Archivo-Medium",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: 12,
        lineHeight: 14,
        color: "#999",
    },
    footer: {
        paddingHorizontal: 12,
        paddingVertical: 16,
        borderTopWidth: 1,
        borderColor: "#eaeaea",
    },
    footerTx: {
        fontFamily: "Archivo-SemiBold",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 12,
        lineHeight: 14,
        color: "#999999",
    },
    icon: {
        padding: 5,
        borderRadius: 100,
        width: 24,
        height: 24,
        backgroundColor: "#F3F3F3",
    },
    flexRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
});

export default SurveyKarakterCard;
